module.exports = __webpack_public_path__ + "img/widget_active.6550e3c6.svg";